import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { faqItems } from '../data/mock';

const FAQSection = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <section ref={ref} className="section-padding bg-[var(--bg-secondary)]">
      <div className="container mx-auto px-6">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          className="text-center max-w-3xl mx-auto mb-12"
        >
          <span className="text-sm text-[var(--accent-primary)] uppercase tracking-widest font-medium">FAQ</span>
          <h2 className="text-3xl md:text-4xl font-bold mt-4 mb-6">
            Frequently Asked
            <span className="text-[var(--accent-primary)]"> Questions</span>
          </h2>
        </motion.div>
        
        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.1 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqItems.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="px-6 rounded-xl bg-[var(--bg-primary)] border border-[var(--border-subtle)] data-[state=open]:border-[var(--accent-primary)] transition-colors"
              >
                <AccordionTrigger className="text-left font-medium py-5 hover:no-underline hover:text-[var(--accent-primary)] transition-colors [&>svg]:text-[var(--accent-primary)]">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-[var(--text-muted)] pb-5">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;